import { ApplicationState } from '../index';

export function GetMinMappingDate(state: ApplicationState): Date | undefined {
    return !!state && !!state.globalSettings && state.globalSettings.minMappingDate;
}
